import Joi from 'joi';
import { YEARS } from '../LegalParameters/Constants';

export const maxOneChildDurationInDays = 196;
export const maxMoreChildrenDurationInDays = 259;

export default Joi.object({
	monthlyIncome: Joi.number()
		.positive()
		.error(() => ({
			message: 'Vyměřovací základ musí být celé kladné číslo!',
		})),
	baseType: Joi.any().allow(['month', 'day']),
	children: Joi.number()
		.integer()
		.positive()
		.min(1),
	year: Joi.valid(YEARS),
});
